import { memo, useState, useCallback } from 'react'
import { createPortal } from 'react-dom'
import { CS_m } from 'back-end-api'

import CameraOn from 'assets/icons/communication/CameraOn'
import Phone from 'assets/icons/communication/Phone'

import { useMiscDispatch } from 'services/Misc'
import { setAppointmentPickedUp, useAudioVisualsState } from 'services/Misc/audioVisuals'
import { green } from 'styles/Colors'

interface TimeCellProps {
  appointment: CS_m.ModelsAppointment
}

const PickUp = ({ appointment }: TimeCellProps) => {
  const miscDispatch = useMiscDispatch()
  const audioVisualState = useAudioVisualsState()
  const [showConfirm, setShowConfirm] = useState(false)

  const handleClick = useCallback(
    (e: { stopPropagation: () => void }) => {
      e.stopPropagation()
      setShowConfirm(true)
    },
    []
  )

  const onConfirm = useCallback(() => {
    setShowConfirm(false)
    setAppointmentPickedUp(miscDispatch, audioVisualState, appointment)
  }, [miscDispatch, audioVisualState, appointment])

  const onCancel = useCallback(() => {
    setShowConfirm(false)
  }, [])

  const patient = appointment?.summary?.registration
  const patientName = patient
    ? `${patient.first_name ?? ''} ${patient.last_name ?? ''}`.trim()
    : ''

  return (
    <>
      <div role="presentation" onClick={handleClick} onKeyDown={handleClick}>
        <CameraOn style={undefined} color={green} />
      </div>

      {showConfirm &&
        createPortal(
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10001,
            }}
            role="presentation"
            onClick={onCancel}
            onKeyDown={onCancel}
          >
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: '2rem 2.5rem',
                maxWidth: '380px',
                width: '90%',
                textAlign: 'center',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                fontFamily: 'coresanscr55, sans-serif',
              }}
              role="presentation"
              onClick={e => e.stopPropagation()}
              onKeyDown={e => e.stopPropagation()}
            >
              {/* Phone icon */}
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: '#33b897',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                }}
              >
                <Phone style={{ width: 22, height: 22 }} color="#ffffff" />
              </div>

              <p
                style={{
                  fontSize: '1rem',
                  color: '#202336',
                  lineHeight: 1.5,
                  margin: '0 0 0.5rem',
                  fontFamily: 'coresanscr65, sans-serif',
                }}
              >
                Pick up call?
              </p>

              {patientName && (
                <p
                  style={{
                    fontSize: '0.875rem',
                    color: 'rgba(32, 35, 54, 0.6)',
                    margin: '0 0 1.5rem',
                  }}
                >
                  {patientName}
                </p>
              )}

              {!patientName && <div style={{ marginBottom: '1.5rem' }} />}

              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                <button
                  type="button"
                  onClick={onCancel}
                  style={{
                    backgroundColor: '#fff',
                    color: '#202336',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    padding: '0.5rem 1.5rem',
                    fontSize: '0.875rem',
                    fontFamily: 'coresanscr65, sans-serif',
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={onConfirm}
                  style={{
                    backgroundColor: '#33b897',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '0.5rem 1.5rem',
                    fontSize: '0.875rem',
                    fontFamily: 'coresanscr65, sans-serif',
                    cursor: 'pointer',
                  }}
                >
                  Pick up
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  )
}

PickUp.whyDidYouRender = true

export default memo(PickUp)
